import { TOUR_IDS } from "@demandproai/shared";
import { TourGateProvider } from "../../contexts/TourGateContext";
import RenderIf from "../render-if/Renderif";
import useEasyModeTour from "../../hooks/useEasyModeTour";
import useTourRefresher from "../../hooks/useTourRefresher";
import TourRefresherPrompt from "./TourRefresherPrompt";

const EasyModeTourRunner = () => {
   const { Tour, gate } = useEasyModeTour();
   const { isOffering, acceptRefresher, declineRefresher } = useTourRefresher({
      tourId: TOUR_IDS.EASY_MODE,
   });

   return (
      <TourGateProvider value={gate}>
         {Tour}

         <RenderIf shouldRender={isOffering}>
            <TourRefresherPrompt onAccept={acceptRefresher} onDecline={declineRefresher} />
         </RenderIf>
      </TourGateProvider>
   );
};

export default EasyModeTourRunner;
